import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog'
import { TabView, TabPanel } from 'primereact/tabview';
import React, { useState } from 'react'
import DataTableDetalheRegras from './DataTableDetalheRegras';
export default function ModalDetalharRegras({ dadosRegra, isVisible, fecharModalAviso }) {
    const { estados = "", cidades = "", inscricoes = "", planos = "", formaPagamento = "" } = dadosRegra

    const arrayFormaPagamento = formaPagamento.split(",")
    const arrayInscricoes = inscricoes.split(",")
    const arrayCidades = cidades.split(",")
    const arrayPlanos = planos.split(",")
    const arrayEstados = estados.split(",")
    const [activeIndex, setActiveIndex] = useState(0)
    const onTabChange = ({ index }) => {
        setActiveIndex(index)
    }
    return (

        <>
            <Dialog header="Visualizar detalhes regras" visible={isVisible} style={{ width: '75vw', textAlign: 'left' }} modal={true} onHide={() => fecharModalAviso(false)}>
                <TabView activeIndex={activeIndex} onTabChange={onTabChange.bind(this)} style={{width: "100%"}}>
                    <TabPanel header="FORMA DE PAGAMENTO" leftIcon='pi pi-dollar'>
                        <span className='view-forma-pagamento'>{formaPagamento}</span>
                    </TabPanel>
                    <TabPanel header="ESTADO" contentClassName='conteudo-abas' leftIcon='pi pi-map-marker'
                     disabled={arrayEstados[0] === "" || arrayEstados[0] === "Todos Estados"}>
                        <DataTableDetalheRegras arrayExibicao={arrayEstados} detalhe='Estados' />
                    </TabPanel>
                    <TabPanel header="CIDADE" contentClassName='conteudo-abas' leftIcon='pi pi-compass'
                     disabled={arrayCidades[0] === "" || arrayCidades[0] === "Todas as Cidades"}>
                        <DataTableDetalheRegras arrayExibicao={arrayCidades} detalhe='Cidades' />
                    </TabPanel>
                    <TabPanel header="PLANO" contentClassName='conteudo-abas' leftIcon='pi pi-sitemap' disabled= {arrayPlanos[0] === "" || arrayPlanos[0] === "Todos Planos"}>
                        <DataTableDetalheRegras arrayExibicao={arrayPlanos} detalhe='Planos' />
                    </TabPanel>
                    <TabPanel header="CLIENTE" contentClassName='conteudo-abas' leftIcon='pi pi-id-card' disabled={arrayInscricoes[0] === "" || arrayInscricoes[0] === "Todos os Clientes"}>
                        <DataTableDetalheRegras arrayExibicao={arrayInscricoes} detalhe='Inscrições' />
                    </TabPanel>
                </TabView>
            </Dialog>
        </>

    )
}
